class Lightbox {
  constructor(selector) {
    this.triggers = document.querySelectorAll(selector);
    this.lightboxEl = null;
    this.contentContainer = null;
    this.footerContainer = null;
    this.thumbnailsContainer = null;
    this.navigationContainer = null;
    this.galleryItems = [];
    this.currentIndex = 0;

    // this.handleKeyDown = this.handleKeyDown.bind(this);

    this.init();
  }

  init() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', event => {
        event.preventDefault();

        const feedContainer = trigger.closest('.feed__container');
        let itemsInContainer;
        if (feedContainer) {
          itemsInContainer = feedContainer.querySelectorAll('[data-lightbox]');
        } else {
          itemsInContainer = [trigger]; // standalone
        }

        this.galleryItems = Array.from(itemsInContainer).map(el => {
          const coverImgEl = el.querySelector('img');
          const coverImgSrc = coverImgEl ? coverImgEl.src : '';

          return {
            image: el.dataset.image || coverImgSrc,
            video: el.dataset.video || '',
            caption: el.dataset.caption || '',
            downloadStandardResolution: el.dataset.downloadStandardResolution || '',
            downloadHighResolution: el.dataset.downloadHighResolution || '',
            download720p: el.dataset.download720p || '',
            download1080p: el.dataset.download1080p || '',
            download4k: el.dataset.download4k || '',
            download8k: el.dataset.download8k || ''
          };
        });

        this.currentIndex = [...itemsInContainer].indexOf(trigger);
        this.openLightbox();
        this.renderItem(this.currentIndex);
      });
    });
  }

  openLightbox() {
    if (this.lightboxEl) {
      if (!this.lightboxEl.open) {
        this.lightboxEl.showModal();
      }
      requestAnimationFrame(() => {
        this.lightboxEl.classList.add('is-visible');
      });
      window.addEventListener('keydown', this.handleKeyDown);
      return;
    }

    this.lightboxEl = document.createElement('dialog');
    this.lightboxEl.classList.add('lightbox');
    document.body.appendChild(this.lightboxEl);

    this.lightboxEl.innerHTML = `
      <div class="lightbox__overlay"></div>
      <div class="lightbox__container">
        <div class="lightbox__wrapper" data-width="wide">
          <div class="lightbox__content"></div>
        </div>
      </div>
      <a href="#" class="lightbox__close">
        <i class="icon icon--close"></i>
      </a>
    `;

    this.contentContainer = this.lightboxEl.querySelector('.lightbox__content');

    // this.footerContainer = document.createElement('div');
    // this.footerContainer.classList.add('lightbox__footer');
    // this.contentContainer.appendChild(this.footerContainer);

    // this.thumbnailsContainer = document.createElement('div');
    // this.thumbnailsContainer.classList.add('lightbox__thumbnails');
    // this.footerContainer.insertAdjacentElement('afterend', this.thumbnailsContainer);

    // this.navigationContainer = document.createElement('div');
    // this.navigationContainer.classList.add('lightbox__navigation');
    // this.navigationContainer.innerHTML = `
    //   <a href="#" class="lightbox__prev"><i class="icon icon--arrow left"></i></a>
    //   <a href="#" class="lightbox__next"><i class="icon icon--arrow"></i></a>
    // `;
    // this.thumbnailsContainer.insertAdjacentElement('afterend', this.navigationContainer);

    // this.setupNavigation();
    this.attachCloseHandlers(this.lightboxEl);

    this.lightboxEl.showModal();
    requestAnimationFrame(() => {
      this.lightboxEl.classList.add('is-visible');
    });

    window.addEventListener('keydown', this.handleKeyDown);
    this.trapFocus();
  }

  trapFocus() {
    const focusableSelectors = 'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
    const focusableEls = this.lightboxEl.querySelectorAll(focusableSelectors);
    const firstFocusable = focusableEls[0];
    const lastFocusable = focusableEls[focusableEls.length - 1];

    this.lightboxEl.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    });
  }

  // setupNavigation() {
  //   const prevLink = this.navigationContainer.querySelector('.lightbox__prev');
  //   const nextLink = this.navigationContainer.querySelector('.lightbox__next');

  //   prevLink.addEventListener('click', e => {
  //     e.preventDefault();
  //     this.showPrevItem();
  //   });

  //   nextLink.addEventListener('click', e => {
  //     e.preventDefault();
  //     this.showNextItem();
  //   });
  // }

  // showPrevItem() {
  //   this.currentIndex = (this.currentIndex - 1 + this.galleryItems.length) % this.galleryItems.length;
  //   this.renderItem(this.currentIndex);
  // }

  // showNextItem() {
  //   this.currentIndex = (this.currentIndex + 1) % this.galleryItems.length;
  //   this.renderItem(this.currentIndex);
  // }

  // handleKeyDown(event) {
  //   if (!this.lightboxEl || !this.lightboxEl.open) return;

  //   if (event.key === 'ArrowLeft') {
  //     event.preventDefault();
  //     this.showPrevItem();
  //   } else if (event.key === 'ArrowRight') {
  //     event.preventDefault();
  //     this.showNextItem();
  //   }
  // }

  renderItem(index) {
    this.currentIndex = index;
    const item = this.galleryItems[index];

    const existingMedia = this.contentContainer.querySelector('.lightbox__image, .lightbox__video');
    if (existingMedia) {
      existingMedia.remove();
    }

    this.showLoader();

    let mediaEl;
    if (item.video) {
      mediaEl = document.createElement('div');
      mediaEl.classList.add('lightbox__video');
      mediaEl.innerHTML = `
        <video controls autoplay preload="auto" playsinline>
          <source src="${item.video}" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      `;
    } else {
      mediaEl = document.createElement('figure');
      mediaEl.classList.add('lightbox__image');
      const img = document.createElement('img');
      img.src = item.image;
      img.alt = item.caption || '';
      mediaEl.appendChild(img);
    }

    this.contentContainer.appendChild(mediaEl);

    const mediaLoadPromise = item.video
      ? new Promise(resolve => mediaEl.querySelector('video').addEventListener('canplay', resolve, { once: true }))
      : new Promise(resolve => mediaEl.querySelector('img').addEventListener('load', resolve, { once: true }));

    mediaLoadPromise.then(() => {
      this.hideLoader();
      mediaEl.style.opacity = 0;
      mediaEl.style.transition = 'opacity 0.4s ease';
      requestAnimationFrame(() => {
        mediaEl.style.opacity = 1;
      });
    });

    // this.updateFooter(item);
    // this.updateThumbnails();
  }

  // updateFooter(item) {
  //   this.footerContainer.innerHTML = '';

  //   if (item.caption) {
  //     const captionEl = document.createElement('figcaption');
  //     captionEl.classList.add('lightbox__caption');
  //     captionEl.textContent = item.caption;
  //     this.footerContainer.appendChild(captionEl);
  //   }

  //   this.updateDownloadLinks(item);
  // }

  // updateDownloadLinks(item) {
  //   const hasAnyDownload = (
  //     item.downloadStandardResolution ||
  //     item.downloadHighResolution ||
  //     item.download720p ||
  //     item.download1080p ||
  //     item.download4k ||
  //     item.download8k
  //   );

  //   if (!hasAnyDownload) return;

  //   const downloadDiv = document.createElement('div');
  //   downloadDiv.classList.add('lightbox__download');
  //   downloadDiv.innerHTML = `<span>Download:</span>`;

  //   if (item.downloadStandardResolution) {
  //     const link = document.createElement('a');
  //     link.href = item.downloadStandardResolution;
  //     link.download = '';
  //     link.innerHTML = `
  //       <span>Standard Resolution</span>
  //       <span class="lightbox__arrow"><i class="icon icon--download"></i></span>
  //     `;
  //     downloadDiv.appendChild(link);
  //   }

  //   if (item.downloadHighResolution && item.downloadHighResolution !== item.downloadStandardResolution) {
  //     const link = document.createElement('a');
  //     link.href = item.downloadHighResolution;
  //     link.download = '';
  //     link.innerHTML = `
  //       <span>High Resolution</span>
  //       <span class="lightbox__arrow"><i class="icon icon--download"></i></span>
  //     `;
  //     downloadDiv.appendChild(link);
  //   }

  //   if (item.download720p) {
  //     const link = document.createElement('a');
  //     link.href = item.download720p;
  //     link.download = '';
  //     link.innerHTML = `<span>720p</span><span class="lightbox__arrow"><i class="icon icon--download"></i></span>`;
  //     downloadDiv.appendChild(link);
  //   }
  //   if (item.download1080p) {
  //     const link = document.createElement('a');
  //     link.href = item.download1080p;
  //     link.download = '';
  //     link.innerHTML = `<span>1080p</span><span class="lightbox__arrow"><i class="icon icon--download"></i></span>`;
  //     downloadDiv.appendChild(link);
  //   }

  //   this.footerContainer.appendChild(downloadDiv);
  // }

  // updateThumbnails() {
  //   if (!this.thumbnailsContainer || this.galleryItems.length <= 1) {
  //     this.thumbnailsContainer.innerHTML = '';
  //     return;
  //   }

  //   if (!this.thumbnailsContainer.hasChildNodes()) {
  //     this.buildThumbnails();
  //   }

  //   const thumbWrappers = this.thumbnailsContainer.querySelectorAll('.lightbox__thumbnail');
  //   thumbWrappers.forEach((wrapper, i) => {
  //     wrapper.classList.toggle('is-active', i === this.currentIndex);
  //   });

  //   const activeThumb = this.thumbnailsContainer.querySelector('.lightbox__thumbnail.is-active');
  //   if (activeThumb) {
  //     const containerLeft = this.thumbnailsContainer.getBoundingClientRect().left;
  //     const thumbLeft = activeThumb.getBoundingClientRect().left;
  //     const scrollOffset = thumbLeft - containerLeft + this.thumbnailsContainer.scrollLeft;
  //     this.thumbnailsContainer.scrollTo({ left: scrollOffset, behavior: 'smooth' });
  //   }
  // }

  // buildThumbnails() {
  //   if (!this.thumbnailsContainer) return;
  //   this.thumbnailsContainer.innerHTML = '';

  //   this.galleryItems.forEach((item, index) => {
  //     const thumbWrapper = document.createElement('div');
  //     thumbWrapper.classList.add('lightbox__thumbnail');

  //     const thumbImg = document.createElement('img');
  //     thumbImg.src = item.image || '';
  //     thumbImg.alt = item.caption || '';

  //     thumbWrapper.appendChild(thumbImg);
  //     thumbWrapper.addEventListener('click', () => {
  //       this.renderItem(index);
  //     });

  //     this.thumbnailsContainer.appendChild(thumbWrapper);
  //   });
  // }

  attachCloseHandlers(dialog) {
    dialog.addEventListener('click', e => {
      const closeButton = e.target.closest('.lightbox__close');
      if (closeButton) {
        e.preventDefault();
        const videoEl = dialog.querySelector('video');
        if (videoEl) {
          videoEl.pause();
          videoEl.currentTime = 0;
        }

        dialog.classList.remove('is-visible');
        setTimeout(() => {
          dialog.close();
          // window.removeEventListener('keydown', this.handleKeyDown);
        }, 200);
      }
    });
  }

  showLoader() {
    if (!this.contentContainer.querySelector('.loader')) {
      const loader = document.createElement('div');
      loader.classList.add('loader');
      loader.setAttribute('role', 'status');
      loader.setAttribute('aria-live', 'polite');
      loader.innerHTML = `
        <div class="loader__grid">
          ${'<div class="loader__cell"></div>'.repeat(9)}
        </div>
      `;
      this.contentContainer.appendChild(loader);
    }
  }

  hideLoader() {
    const loader = this.contentContainer.querySelector('.loader');
    if (loader) {
      loader.remove();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Lightbox('[data-lightbox]');
});